module.exports = __webpack_public_path__ + "static/media/fabuBuss.a2e1c79c.svg";